'use strict';

angular.module('broadcastsModule')
.controller('EditBroadcastsFolderCtrl', EditBroadcastsFolderCtrl);


function EditBroadcastsFolderCtrl ($scope, model, Uploader, BroadcastsFile)
{
    $scope.model = model;
    $scope.modelNameField = 'name';
    $scope.tagging = false;

    $scope.uploader = new Uploader({autoUpload: true});
    $scope.uploader.onSuccessItem = onSuccessItem;
    $scope.remove = remove;

    BroadcastsFile.bindAll({broadcast_id: $scope.model.id}, $scope, 'files');

    $scope.$watch('model.id', function ()
    {
        $scope.uploader.formData = [{broadcast_id: $scope.model.id}];
    });

    this.saveFolder = function ()
    {
        $scope.model.DSCreate({upsert: true}).then($scope.$close);
    };

    function remove (fileItem)
    {
        // for editing asset, existing files, already bind File to this item
        if (fileItem.DSDestroy) {
            fileItem.DSDestroy();
        } else {
            fileItem.remove();
        }
    }

    function onSuccessItem (fileItem, response)
    {
        // remove from uploader.queue
        fileItem.remove();

        var params = {broadcast_id: model.id};
        BroadcastsFile.ejectAll(params);
        $scope.file = [BroadcastsFile.inject(response)];
    }
};
